import classNames from "classnames";
import { useField } from "formik";
import React from "react";
import { doesMetaHaveError, renderErrorMessage } from "./Tools";

export function isChecked(value: string | boolean | null | undefined) {
  return typeof value === "string"
    ? value.toLowerCase() !== "false"
    : ![false, null, undefined].includes(value);
}

export function Checkbox(props: {
  fieldName: string;
  children?: React.ReactNode;
  noVerticalSlop?: boolean;
}) {
  const [field, meta] = useField(props.fieldName);
  return (
    <div className="control">
      <input
        className={classNames("is-checkradio", {
          "input-validation-error": doesMetaHaveError(meta),
        })}
        id={props.fieldName}
        type="checkbox"
        {...field}
        checked={isChecked(field.value)}
        value="true"
      />
      <label
        htmlFor={props.fieldName}
        className={classNames({ "no-vertical-slop": props.noVerticalSlop })}
      >
        {props.children}
      </label>
      {renderErrorMessage(meta)}
      <input
        name={props.fieldName}
        type="hidden"
        value="false"
        disabled={isChecked(field.value)}
      />
    </div>
  );
}
